export const Spacer = ({ height = '24px' }: { height: string }) => {
  return <div data-testid="spacer" className="w-full" style={{ height }} />;
};
